export default __webpack_public_path__ + "static/media/10.4937d522.webp";